<!--
  ~ Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
  ~
  ~ Please see distribution for license.
  -->
<h2>Users</h2>

@if (loadingUsers$ | async) {
<div class="spinner">
  <mat-progress-spinner [mode]="'indeterminate'" [color]="'primary'"></mat-progress-spinner>
</div>
} @else {
<section class="og-container">
  <og-tenant-users-filter (filterUpdated)="usersFilter$.next($event)"></og-tenant-users-filter>
  @for (user of filteredUsers$ | async; track user) {
  <mat-expansion-panel class="container__panel">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon class="user-panel__icon">
          {{ isOpenGammaUser(user) ? 'home' : 'work' }}
        </mat-icon>
        {{ user.firstName + ' ' + user.lastName }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    @if (!userToDelete || userToDelete.email !== user.email) {
    <div class="og-content">
      <div class="content__details">
        <h3 class="details__header">Email</h3>
        <h3 class="details__content">{{ user.email }}</h3>
      </div>
      <div class="content__details content__details--picture">
        <h3 class="details__header">Picture</h3>
        <img class="details__photo" alt="user picture" [src]="user.picture" />
      </div>
    </div>
    <div class="buttons">
      @if (isSelectedTenantEditable$ | async) {
      <button mat-raised-button (click)="userToDelete = user">
        <i class="material-icons">delete</i>
        Delete
      </button>
      }
    </div>
    } @if (!!userToDelete && userToDelete.email === user.email) {
    <og-confirmation-panel
      [text]="constructDeletionConfirmationText()"
      (cancelClicked)="userToDelete = undefined"
      (confirmClicked)="onUserDeletion(issueKey.value)"
    >
      <div [hidden]="!(isApprovalIdRequired$ | async)">
        <mat-form-field>
          <input
            matInput
            placeholder="JIRA ID"
            #issueKey
            [required]="isApprovalIdRequired$ | async"
          />
        </mat-form-field>
      </div>
    </og-confirmation-panel>
    }
  </mat-expansion-panel>
  } @if (isAddUserPanelVisible$ | async) {
  <mat-card appearance="outlined" class="container__add">
    <og-user-details-form
      [userDetails]="newUserData$ | async"
      [loading]="userCreationInProgress$ | async"
      (userUpdateChange)="onNewUserUpdate($event)"
      (userSaveChange)="onUserSave($event)"
      (formCancelChange)="hideAddUserPanel()"
      [isApprovalIdRequired]="isApprovalIdRequired$ | async"
    ></og-user-details-form>
  </mat-card>
  } @if (isSelectedTenantEditable$ | async) {
  <div class="button__container">
    <button mat-fab color="accent" (click)="showAddUserPanel()">
      <i class="material-icons">add</i>
    </button>
  </div>
  }
</section>
}
